import { Fab as materialFab } from '@material-ui/core';
import materialAdd from '@material-ui/icons/Add';
import { styled as materialStyled } from '@material-ui/core/styles';

export const Fab = materialStyled(materialFab)({
  backgroundColor: '#f76d31',
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
  '&:hover': {
    background: '#f76d31',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.2)',
  },
  position: 'fixed',
  right: '30px',
  bottom: '30px',
});

export const AddIcon = materialStyled(materialAdd)({
  color: 'white',
});
